function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  stroke: "#000",
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("path", {
  d: "M7.92 1a2.922 2.922 0 00-2.923 2.922v40.154a2.922 2.922 0 002.922 2.922h32.162a2.922 2.922 0 002.922-2.922V13.647c0-.798-.327-1.56-.903-2.112L31.927 1.81a2.922 2.922 0 00-2.02-.81H7.92z",
  fill: "#FFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M30.633 1.04v10.578a1.96 1.96 0 001.961 1.96h10.044"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.734 21.559h20.532m-20.532 8.213h20.532m-20.532 8.212h20.532",
  strokeLinecap: "round"
}));

var SvgDocumentIcon = function SvgDocumentIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDocumentIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/document-icon.d8741aa5.svg";
export { ForwardRef as ReactComponent };